



























import { Prop, Component, Vue, Mixins } from 'vue-property-decorator';
import TileComponentMixin from '@/mixins/TileComponentMixin';
import BaseNumbersTile, { IBaseNumbersTileConfiguration } from './BaseNumbersTile.vue';
import { Getter } from 'vuex-class';
import { IN2KWaterDepthEvent } from '../../common/apis/DeviceApi';
import UserMixin from '@/mixins/UserMixin';

@Component({
    components: {
        BaseNumbersTile,
    },
})
export default class WaterDepthTile extends Mixins(TileComponentMixin, UserMixin) {
    @Prop({required: false})
    public configuration?: IBaseNumbersTileConfiguration;

    public get available() {
        if (this.lastEvent) {
            return true;
        }
        return false;
    }

    public get lastEvent(): IN2KWaterDepthEvent | null {
        let data = this.getWaterDepth(this.deviceNumber);
        if (!data && this.isDemo) {
            data = this.demoData;
        }
        return data;
    }

    public get depth(): string {
        if (this.lastEvent && this.lastEvent.depth) {
            return (Math.round((this.lastEvent.depth + (this.lastEvent.offset || 0)) * 10) / 10).toFixed(1);
        }
        return '--';
    }

    public get ageInSeconds(): number {
        if (this.lastEvent && this.lastEvent.timestamp) {
            const timestamp = typeof this.lastEvent.timestamp === 'object'
                ? this.lastEvent.timestamp
                : new Date(this.lastEvent.timestamp);

            return (new Date().getDate() - timestamp.getDate()) / 1000;
        }
        return 999;
    }

    @Getter('n2k/waterDepth')
    private getWaterDepth: (deviceNumber: string) => IN2KWaterDepthEvent | null;
    private demoData: IN2KWaterDepthEvent | null = null;
    private demoDataInterval: number;

    public mounted() {
        if (this.isDemo) {
            this.generateDemoData();
            this.demoDataInterval = setInterval(this.generateDemoData, 1000);
        }
    }
    public async beforeDestroy() {
        clearInterval(this.demoDataInterval);
    }

    private generateDemoData() {
        let depth = this.demoData ? this.demoData.depth || 0 : 0;

        depth += Math.random() * 0.2 - 0.1;
        if (depth > 20) {
            depth = 20;
        }
        if (depth < 2) {
            depth = 2;
        }

        this.demoData = {
            depth,
            offset: 1.4,
            sensorNumber: 0,
            deviceNumber: this.deviceNumber,
            timestamp: new Date(),
        };
    }
}
